module.exports = __webpack_public_path__ + "media/images/logos/isaac-logo-purple-b93a3d4be9a0a7c286d0d3f93d3b9380.svg";